import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import IndexedDBService from '../../../../../../../../services/indexedDB/IndexedDB.service';
import inspectionUploadService from '../../../../../../services/inspection-upload.service';

const ConfirmCleanSentList = (props: any) => {
  const {
    open,
    handleClose,
    keepIdentifiers = [],
  } = props;

  const cleanSentList = async () => {
    await IndexedDBService.deleteAllSentRegister(keepIdentifiers);
    inspectionUploadService.callRefreshList();
    handleClose();
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      data-testid="clean-sent-dialog"
      PaperProps={{
        sx: {
          width: '312px',
          maxWidth: '312px',
          boxSizing: 'border-box',
          margin: 0,
          padding: '24px',
          gap: '20px',
          borderRadius: '12px',
          border: '0.5px solid #9FB4D4',
        },
      }}
    >
      <DialogTitle
        id="alert-dialog-title"
        sx={{
          padding: 0,
          fontFamily: "'Poppins' !important",
          fontWeight: 600,
          fontSize: '18px',
          lineHeight: '24px',
          color: '#262626',
        }}
      >
        Esvaziar a lista de vistorias?
      </DialogTitle>
      <DialogContent sx={{ padding: 0 }}>
        <DialogContentText
          id="alert-dialog-description"
          data-testid="alert-dialog-description"
          sx={{
            fontFamily: "'Poppins' !important",
            fontSize: '14px',
            lineHeight: '24px',
            color: '#4D4D4D',
          }}
        >
          Apenas as vistorias já enviadas serão removidas da lista deste
          dispositivo. <b>Essa ação não altera os dados das vistorias enviadas.</b>
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          padding: 0,
          flexDirection: 'column',
          gap: '10px',
          '& > :not(:first-of-type)': { marginLeft: 0 },
        }}
      >
        <Button
          fullWidth
          className='black-button'
          onClick={cleanSentList}
          data-testid="confirm-clean-button"
        >Sim, esvaziar</Button>
        <Button
          fullWidth
          variant='outlined'
          className='secondary-button'
          onClick={handleClose}
          data-testid="cancel-clean-button"
        >
          Voltar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmCleanSentList;
